var __WEBPACK_NAMESPACE_OBJECT__ = require("zotero-translation-client");